import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Logo } from "./Logo";
import { useWishlist } from "../lib/wishlist";
import { Menu, X, Heart } from "lucide-react";
import { NotificationBell } from "./NotificationBell";

export const Header = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const { count } = useWishlist();

  const navItems = [
    { to: "/#promozioni", label: "Auto in Promozione", testId: "nav-promo", highlight: true },
    { to: "/", label: "Parco Auto", testId: "nav-home" },
    { to: "/vendi", label: "Vendi la Tua Auto", testId: "nav-sell" },
    { to: "/richiedi", label: "Richiedi un'Auto", testId: "nav-request" },
    { to: "/assicurazione", label: "Assicurazione", testId: "nav-insurance" },
    { to: "/demolizione", label: "Demolizione", testId: "nav-demolition" },
    { to: "/contatti", label: "Contatti", testId: "nav-contact" },
  ];

  return (
    <header
      className="sticky top-0 z-40 glass-dark border-b border-white/10"
      data-testid="site-header"
    >
      <div className="w-full pl-5 md:pl-8 pr-5 md:pr-10 h-20 md:h-24 flex items-center justify-between gap-6">
        <Link to="/" className="shrink-0 mt-8 logo-halo" data-testid="header-logo-link">
          <Logo size="lg" tone="light" />
        </Link>

        <nav className="hidden md:flex items-center gap-6 flex-wrap justify-end">
          {navItems.map((n, idx) => (
            <Link
              key={n.to}
              to={n.to}
              data-testid={n.testId}
              className={`text-sm tracking-wide uppercase font-medium transition-colors ${
                n.highlight
                  ? "animate-blink-gold ml-4"
                  : location.pathname === n.to
                  ? "text-white"
                  : "text-white/70 hover:text-gold"
              }`}
            >
              {n.label}
            </Link>
          ))}
          <Link
            to="/preferiti"
            className={`relative inline-flex items-center gap-1.5 text-sm tracking-wide uppercase font-medium transition-colors ${
              location.pathname === "/preferiti" ? "text-gold" : "text-white/70 hover:text-gold"
            }`}
            data-testid="nav-wishlist"
            aria-label={`Preferiti (${count})`}
          >
            <Heart size={16} fill={count > 0 ? "currentColor" : "none"} strokeWidth={2} />
            {count > 0 && (
              <span
                className="min-w-[18px] h-[18px] px-1 flex items-center justify-center text-[10px] font-bold text-midnight bg-gold rounded-full"
                data-testid="nav-wishlist-count"
              >
                {count}
              </span>
            )}
          </Link>
          <NotificationBell />
          <Link
            to="/admin/login"
            className="text-xs tracking-widest uppercase text-white/70 hover:text-gold transition-colors"
            data-testid="nav-admin"
          >
            Area Riservata
          </Link>
        </nav>

        <div className="md:hidden flex items-center gap-3">
          <Link
            to="/preferiti"
            className="relative inline-flex items-center p-2"
            aria-label={`Preferiti (${count})`}
            data-testid="nav-wishlist-mobile"
          >
            <Heart size={20} fill={count > 0 ? "#D4AF37" : "none"} className={count > 0 ? "text-gold" : "text-white/70"} strokeWidth={2} />
            {count > 0 && (
              <span className="absolute -top-0.5 -right-0.5 min-w-[16px] h-[16px] px-1 flex items-center justify-center text-[9px] font-bold text-midnight bg-gold rounded-full">
                {count}
              </span>
            )}
          </Link>
          <NotificationBell compact />
          <button
            className="p-2 text-white"
            onClick={() => setOpen((o) => !o)}
            aria-label="Menu"
            data-testid="mobile-menu-toggle"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-white/10 bg-midnight text-white" data-testid="mobile-menu">
          <div className="px-5 py-4 flex flex-col gap-4">
            {navItems.map((n) => (
              <Link
                key={n.to}
                to={n.to}
                onClick={() => setOpen(false)}
                className={`text-base font-medium ${n.highlight ? "animate-blink-gold" : "text-white"}`}
                data-testid={`${n.testId}-mobile`}
              >
                {n.label}
              </Link>
            ))}
            <Link
              to="/preferiti"
              onClick={() => setOpen(false)}
              className="text-base font-medium text-white inline-flex items-center gap-2"
              data-testid="nav-wishlist-mobile-menu"
            >
              <Heart size={16} className="text-gold" /> Preferiti {count > 0 && <span className="text-gold">({count})</span>}
            </Link>
            <Link
              to="/admin/login"
              onClick={() => setOpen(false)}
              className="text-sm text-white/60 pt-2 border-t border-white/10"
              data-testid="nav-admin-mobile"
            >
              Area Riservata
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
